<template>
  <div class="w-full grid place-items-center">
    <div
      class="w-12 h-12 rounded-full animate-spin border-4 border-solid border-violet-700 border-t-transparent shadow-md"
    ></div>
  </div>
</template>
